module.exports = __webpack_public_path__ + "static/media/img-not-found.b8b3dd8b.png";